import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { Row, Col, Modal, Button, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { REST_API, FORM_MODE, STATE_STATUS } from '@awp/constants';
import {
  currentAnalysis,
  setEditing,
  setAnalysis,
  currentWeatherForecast,
  currentWeatherObservation,
  setWeatherObservation,
  currentWeatherForecastExternalObjects,
} from '@stores/hazardForecastSlice';
import WeatherForecastModal from './SupportingWeatherForecast/EntityModal';
import { maxTotalSize, maxFileSize } from './SupportingWeatherForecast/helpers';
import { Crud } from '@awp/shared/Crud';

const CreateSupportingModal = ({
  analysisMode,
  setAnalysisMode,
  observationMode,
  setForecastMode,
  setObservationMode,
  eventId,
  visible,
  setWsObservationLoading,
  getForecastWeatherObs,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const selectedAnalysis = useSelector(currentAnalysis);
  const selectedWeatherForecast = useSelector(currentWeatherForecast);
  const selectedWeatherObservation = useSelector(currentWeatherObservation);
  const weatherForecastExternalObjects = useSelector(currentWeatherForecastExternalObjects);
  const [option, setOption] = useState(null);
  const [show, setShow] = useState(visible);
  const [showWeatherForecastModal, setShowWeatherForecastModal] = useState(false);
  const [stError, setStError] = useState(false);

  const crud = new Crud('Select Supporting Data to Add');

  const handleClose = useCallback(() => {
    // removeEmptyPlacement();
    cleanData();
    // setStError(false);
    closeModal();
  }, []);
  //}, [currentSensorEquipmentPacket]);

  useEffect(() => {
    //setStError(false);
    setShow(visible);
  }, [visible]);

  const removeEmptyPlacement = () => {
    // let _data = { ...currentSensorEquipmentPacket };
    // let _sensorEquipmentSets = [..._data.SensorEquipmentSets];
    // let _newSensorEquipmentSets = [];
    // _sensorEquipmentSets.map((sp) => {
    // 	if (sp.SensorPlacementId !== SENSOR_PLACEMENT_CONFIG.ID) _newSensorEquipmentSets.push(sp);
    // });
    // _data.SensorEquipmentSets = _newSensorEquipmentSets;
    // dispatch(
    // 	setData(_data)
    // );
  };

  const cleanData = () => {
    // dispatch(
    // 	setEditing(null)
    // );
    // dispatch(
    // 	setOrignPlacement(null)
    // );
    // dispatch(
    // 	setPlacement(null)
    // );
    // dispatch(
    // 	setSaveError(null)
    // );
    setOption(null);
  };

  const createNewSensorPlacement = (e) => {
    // setStError(false);
    // const sensorTypeId = e.value + "";
    // const st = sensorTypeList.find((opt) => opt.value == sensorTypeId);
    // let newSensorPlacement = {
    // 	SensorPlacementId: SENSOR_PLACEMENT_CONFIG.ID,
    // 	SensorTypeId: sensorTypeId,
    // 	SensorTypeName: st.label,
    // 	PlacementName: getPlacementNumber(st.displayName),
    // 	WeatherStationId: weatherStationId,
    // 	StructuredAttributes: st.PlacementAttributeSchema,
    // 	SensorObservationTypes: [],
    // 	IsCollapsed: 2, ////0/1 collapsed//2 expanded
    // };
    // dispatch(
    // 	setPlacement(newSensorPlacement)
    // );
    // dispatch(
    // 	setEditing(SENSOR_PLACEMENT_CONFIG.PLACEMENT_TAG + newSensorPlacement.SensorPlacementId)
    // );
  };

  const handleSupportingSubmit = () => {
    if (option === 'support_wobs') {
      let _dto = {
        startTimestamp: null,
        endTimestamp: new Date(),
        isStandard: false,
      };
      getForecastWeatherObs('modal', _dto);
      setObservationMode(FORM_MODE.CREATE);
      cleanData();
      closeModal();
    } else if (option === 'support_wf') {
      setShowWeatherForecastModal(true);
    } else if (option === 'support_analysis') {
      dispatch(setAnalysis({}));
      setAnalysisMode(FORM_MODE.CREATE);
      cleanData();
      closeModal();
    }
  };

  const onChangeOptions = (e) => {
    if (e && e.target && e.target.id) setOption(e.target.id);
  };

  const totalFileSize = _.sumBy(weatherForecastExternalObjects, (v) => v.ObjectSizeBytes);
  const remainingSize = maxTotalSize - totalFileSize;
  const targetSize = remainingSize > maxFileSize ? maxFileSize : remainingSize;
  const canAddMoreFiles = weatherForecastExternalObjects.length < 10 && totalFileSize < maxTotalSize;

  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static" centered>
        <Modal.Header closeButton>{crud.getModalTitle()}</Modal.Header>
        <Modal.Body>
          <Form.Group className="my-1">
            <Form.Label>
              <b>Supporting events</b>
            </Form.Label>
            <Row>
              <Col>
                <Form.Check
                  type="radio"
                  inline
                  id="support_wobs"
                  name="r_select"
                  label="Weather Observations"
                  onChange={onChangeOptions}
                  disabled={selectedWeatherObservation}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Check
                  type="radio"
                  inline
                  id="support_wf"
                  name="r_select"
                  label="Weather Forecast"
                  onChange={onChangeOptions}
                  disabled={selectedWeatherForecast || !canAddMoreFiles}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Check
                  type="radio"
                  inline
                  id="support_analysis"
                  name="r_select"
                  label="Analysis"
                  onChange={onChangeOptions}
                  disabled={selectedAnalysis}
                />
              </Col>
            </Row>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSupportingSubmit} disabled={!option}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
      <WeatherForecastModal
        eventId={eventId}
        mode="add"
        targetSize={targetSize}
        show={showWeatherForecastModal}
        onClose={() => {
          setShowWeatherForecastModal(false);
          cleanData();
          closeModal();
        }}
      />
    </>
  );
};

CreateSupportingModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default CreateSupportingModal;
